module.exports = "<h2>\n  This page was not found!\n</h2>\n"


//////////////////
// WEBPACK FOOTER
// D:/IT-Projects/Projects/amortization/amortization-v03.1.1/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main